var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeart = function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M11.58.5c.505 0 1.009.071 1.488.232 2.953.96 4.017 4.2 3.128 7.032a10.2 10.2 0 0 1-2.407 3.847 30.8 30.8 0 0 1-5.065 3.968l-.2.121-.208-.129a30.5 30.5 0 0 1-5.095-3.968A10.35 10.35 0 0 1 .812 7.764C-.092 4.932.972 1.692 3.957.715q.35-.12.711-.167h.096Q5.101.499 5.436.5h.088a5 5 0 0 1 1.465.264h.047a.3.3 0 0 1 .072.047c.177.057.344.121.504.21l.304.135c.073.04.156.1.227.15q.069.052.117.082l.04.023c.068.04.14.082.2.128A5 5 0 0 1 11.58.5m2.127 5.76a.66.66 0 0 0 .632-.609v-.095a2.64 2.64 0 0 0-1.688-2.528.64.64 0 0 0-.808.4.654.654 0 0 0 .4.823c.513.192.856.697.856 1.256v.025c-.015.183.04.36.152.496a.67.67 0 0 0 .456.232",
    clipRule: "evenodd"
  })));
};
export default SvgHeart;